var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cln",class:`${
    !_vm.$device.isDesktop ? 'mobile' : ''
  }`},[_c('nuxt',{staticClass:"content-scroll"}),_vm._v(" "),(_vm.error)?_c('Error',{attrs:{"error":_vm.error}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }